



















import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import DatePickerMenu from "../DatePickerMenu.vue";

@Component({ components: { DatePickerMenu } })
export default class ConditionalDate extends Vue {
  @Prop()
  readonly value!: string;

  updateDate(date: string): void {
    this.$emit("input", date);
  }

  get selected(): boolean {
    return !!this.value;
  }

  set selected(select: boolean) {
    if (!select) this.updateDate("");
    else this.updateDate(new Date().toLocaleDateString());
  }

  @Prop({ default: "Default?" })
  readonly question!: string;

  @Prop({ default: "Default label" })
  readonly label!: string;

  @Prop({ default: false })
  readonly readonly!: boolean;
}
